/**
 * Wrappers Mobile para paginas compartilhadas (admin) usadas no perfil Professor.
 * Adiciona header, voltar e tab bar no mobile sem modificar os componentes originais.
 */
import { MobilePageWrapper } from '../../components/layout/MobilePageWrapper';
import { ComunicadosProfessorDesktop } from './ComunicadosProfessorDesktop';
import { MeusAlunosDesktop } from './MeusAlunosDesktop';
import { ConfiguracoesPage } from '../shared/ConfiguracoesPage';
import { Settings } from 'lucide-react';
import { MobileComunicados } from './MobileComunicados';
import { MobileAlunosList } from './MobileAlunosList';
import { useState, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function useIsMobile(bp = 768) {
  const [m, setM] = useState(() => typeof window !== 'undefined' ? window.innerWidth < bp : false);
  useEffect(() => { const h = () => setM(window.innerWidth < bp); window.addEventListener('resize', h); return () => window.removeEventListener('resize', h); }, [bp]);
  return m;
}

export function ProfessorComunicadosPage() {
  const isMobile = useIsMobile();
  if (isMobile) return <MobileComunicados />;
  return (
    <div
      className="com-desk-host"
      style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}
    >
      <ComunicadosProfessorDesktop />
    </div>
  );
}

export function ProfessorAlunosPage() {
  const isMobile = useIsMobile();
  const location = useLocation();
  const navigate = useNavigate();
  const initialAlunoId = useMemo(() => {
    const state = location.state as { fichaId?: string } | null;
    return state?.fichaId ?? null;
  }, [location.state]);

  useEffect(() => {
    if (!isMobile && initialAlunoId) {
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [isMobile, initialAlunoId, location.pathname, navigate]);

  if (isMobile) return <MobileAlunosList />;
  return (
    <div
      className="alu-desk-host"
      style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, overflow: 'visible' }}
    >
      <MeusAlunosDesktop initialAlunoId={initialAlunoId} />
    </div>
  );
}

import { ProfessorPerfilPremiumPage } from './ProfessorPerfilPremiumPage';

export function ProfessorPerfilPage() {
  return <ProfessorPerfilPremiumPage />;
}

export function ProfessorConfiguracoesPage() {
  return (
    <MobilePageWrapper title="Configuracoes" icon={Settings} iconColor="#94a3b8">
      <ConfiguracoesPage />
    </MobilePageWrapper>
  );
}
